import { render, staticRenderFns } from "./November_2022.vue?vue&type=template&id=0594a1e7&scoped=true&"
import script from "./November_2022.vue?vue&type=script&lang=js&"
export * from "./November_2022.vue?vue&type=script&lang=js&"
import style0 from "./November_2022.vue?vue&type=style&index=0&id=0594a1e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594a1e7",
  null
  
)

export default component.exports